import { useAccount } from '../../../auth/hooks/useAccount'
import { isLocalDev } from '../../../../env/utils/isLocalDev'

export function useLoadDevToolsNavIndicators() {
  const { isRealizeAdmin } = useAccount().user
  return isLocalDev || isRealizeAdmin
}
